require('./iron/common/components/button');
require('./iron/common/components/svg-icon');
require('./iron/common/components/switch');
require('./media/js/gdpr');
require('./media/js/gdpr/settings-privacy');
